type OwnPros = {
  statusColor: string | null;
  text: string | null;
};

export default function StatusIndicator({ statusColor, text }: OwnPros) {
  return (
    <div className="flex h-24 flex-shrink-0 items-center rounded-xl border border-grey-2 px-8 text-center">
      <div
        data-qa="status-badge-color"
        className={`mr-8 h-8 w-8 rounded-full ${statusColor}`}
      />
      <h6 data-qa="status-badge-text" className="tl-body-s">
        {text}
      </h6>
    </div>
  );
}
